import React from 'react'

const RSVTesting = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-4 pt-lg-3 pt-4'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    RSV Testing In Chicago
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-3'>
                <div className='fs-ss-20-2 text-montserrat fw-600 text-ss-black lh-1-2 pb-2 pt-1' style={{ fontStyle:'italic'}}>
                    Respiratory Syncytial Virus
                </div>
            </div>

            <div className=''>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                The respiratory syncytial virus, also known as RSV, is a common virus that typically causes mild symptoms resembling those of a cold. The most common viral cause of acute respiratory tract infection is a respiratory syncytial virus (RSV). Even though RSV affects people of all ages, the disease is more severe in infants, resulting in significant morbidity and hospitalization in young children and the elderly. United Lab Care offer comprehensive<strong> RSV test in Chicago.</strong>
                </div>
            </div>
        </div>
    </div>
  )
}

export default RSVTesting